import { Component, ViewChild } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { ConfigurationServices } from "../services";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationPage } from '../configuration';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';

/**
 * Generated class for the ConfigurationRobotsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-configuration-pudu-robots',
    templateUrl: 'configuration-pudu-robots.html',
})
export class ConfigurationPuduRobotsPage {
    tips: boolean;
    form: FormGroup;
    form_device: FormGroup;
    server_up: boolean = false;
    tables: any;
    tables_robot: any = [];
    table_robot_ids: any = [];
    group_id: string = '';
    robots: any = [];
    loadingPopup: any;

    @ViewChild(DatatableComponent) table: DatatableComponent;
    ColumnMode = ColumnMode;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public configurationServices: ConfigurationServices,
        public globals: Globals,
        public fb: FormBuilder,
        private toastCtrl: ToastController,
        public translate: TranslateService,
        public http: HttpClient,
        public loadingCtrl: LoadingController) {

        //check is undefined to initialize string empty
        if (!this.globals.restaurant.pudu_robots_ip_sdk) {
            this.globals.restaurant.pudu_robots_ip_sdk = '';
        }
        if (!this.globals.restaurant.pudu_robots_port_sdk) {
            this.globals.restaurant.pudu_robots_port_sdk = '';
        }
        if (!this.globals.restaurant.pudu_robots_sdk_device_name) {
            this.globals.restaurant.pudu_robots_sdk_device_name = '';
        }
        if (!this.globals.restaurant.pudu_robots_sdk_device_id) {
            this.globals.restaurant.pudu_robots_sdk_device_id = '';
        }
        if (!this.globals.restaurant.pudu_robots_sdk_device_secret) {
            this.globals.restaurant.pudu_robots_sdk_device_secret = '';
        }
        if (!this.globals.restaurant.pudu_robots_sdk_region) {
            this.globals.restaurant.pudu_robots_sdk_region = '';
        }

        //init forms
        this.form = fb.group({
            pudu_robots_ip_sdk: [this.globals.restaurant.pudu_robots_ip_sdk, Validators.compose([Validators.required])],
            pudu_robots_port_sdk: [this.globals.restaurant.pudu_robots_port_sdk, Validators.compose([Validators.required])],

        });
        this.form_device = fb.group({
            pudu_robots_sdk_device_name: [this.globals.restaurant.pudu_robots_sdk_device_name, Validators.compose([Validators.required])],
            pudu_robots_sdk_device_id: [this.globals.restaurant.pudu_robots_sdk_device_id, Validators.compose([Validators.required])],
            pudu_robots_sdk_device_secret: [this.globals.restaurant.pudu_robots_sdk_device_secret, Validators.compose([Validators.required])],
            pudu_robots_sdk_region: [this.globals.restaurant.pudu_robots_sdk_region, Validators.compose([Validators.required])],
        });
    }

    ionViewWillEnter() {
        this.puduGetDevices();
        this.puduGetRobotsInfo();
        this.getTablesToSync();
    }

    submit() {
        if (this.form.valid) {
            this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
                'pudu_robots_ip_sdk': this.form.value.pudu_robots_ip_sdk,
                'pudu_robots_port_sdk': this.form.value.pudu_robots_port_sdk,
            }).then(data => {
                this.globals.restaurant.pudu_robots_ip_sdk = this.form.value.pudu_robots_ip_sdk;
                this.globals.restaurant.pudu_robots_port_sdk = this.form.value.pudu_robots_port_sdk;
                this.puduGetDevices();
            });

        } else {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('general-rellena-todos-los-campos') ,
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        }
    }

    submit_device() {
        this.loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: ''
        });
        this.loadingPopup.present();

        if (this.form_device.valid) {
            this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
                'pudu_robots_sdk_device_name': this.form_device.value.pudu_robots_sdk_device_name,
                'pudu_robots_sdk_device_id': this.form_device.value.pudu_robots_sdk_device_id,
                'pudu_robots_sdk_device_secret': this.form_device.value.pudu_robots_sdk_device_secret,
                'pudu_robots_sdk_region': this.form_device.value.pudu_robots_sdk_region
            }).then(data => {
                this.globals.restaurant.pudu_robots_sdk_device_name = this.form_device.value.pudu_robots_sdk_device_name;
                this.globals.restaurant.pudu_robots_sdk_device_id = this.form_device.value.pudu_robots_sdk_device_id;
                this.globals.restaurant.pudu_robots_sdk_device_secret = this.form_device.value.pudu_robots_sdk_device_secret;
                this.globals.restaurant.pudu_robots_sdk_region = this.form_device.value.pudu_robots_sdk_region;
            });
            //
            if (this.globals.restaurant.pudu_robots_service_up) {
                this.puduDeleteDevice();
                //reset vars
                this.tables = [];
                this.tables_robot = [];
                this.table_robot_ids = [];
                this.group_id = '';
                this.robots = [];
            } else {
                this.puduAddDevice();
            }
        } else {
            let toast = this.toastCtrl.create({
                message: "Rellena todos los campos",
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        }
    }

    async getTablesToSync() {
        if (this.globals.restaurant.pudu_robots_service_up) {
            this.tables = [];
            this.tables_robot = [];
            this.table_robot_ids = [];
            this.tables = await this.configurationServices.getAllTables();
            this.puduGetGroupsRobots();
        }
    }

    puduGetDevices() {
        if (this.globals.restaurant.pudu_robots_ip_sdk != '' && this.globals.restaurant.pudu_robots_port_sdk != '') {
            return this.http.get('http://' + this.globals.restaurant.pudu_robots_ip_sdk + ':' + this.globals.restaurant.pudu_robots_port_sdk + '/api/devices', {})
                .subscribe(res => {
                    this.server_up = true;
                    if (res['data']['devices'].length > 0) {
                        this.globals.restaurant.pudu_robots_service_up = true;
                        //en el restaurante marcamos que tiene el dispositivo conectado
                        this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
                            'pudu_robots_service_up': true,
                        });
                    } else {
                        this.globals.restaurant.pudu_robots_service_up = false;
                        this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
                            'pudu_robots_service_up': false,
                        });
                    }
                }, error => {
                    this.server_up = false;
                    let toast = this.toastCtrl.create({
                        message: this.translate.instant('general-configura-los-datos-de-conexion') ,
                        duration: 3000,
                        position: 'bottom'
                    });
                    toast.present();
                });
        }
    }

    puduAddDevice() {
        const params = new HttpParams()
            .set('deviceName', this.globals.restaurant.pudu_robots_sdk_device_name)
            .set('deviceId', this.globals.restaurant.pudu_robots_sdk_device_id)
            .set('deviceSecret', this.globals.restaurant.pudu_robots_sdk_device_secret)
            .set('region', this.globals.restaurant.pudu_robots_sdk_region);

        this.http.post('http://' + this.globals.restaurant.pudu_robots_ip_sdk + ':' + this.globals.restaurant.pudu_robots_port_sdk + '/api/add/device', params, {})
            .subscribe(res => {
                if (res['data']['success']) {
                    this.globals.restaurant.pudu_robots_service_up = true;
                    //en el restaurante marcamos que tiene el dispositivo conectado
                    this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
                        'pudu_robots_service_up': true,
                    });
                    //gets
                    this.puduGetRobotsInfo();
                    this.getTablesToSync();
                }
            },
                err => {});
        this.loadingPopup.dismiss();
    }

    puduDeleteDevice() {
        const params = new HttpParams()
            .set('deviceId', this.globals.restaurant.pudu_robots_sdk_device_id);

        this.http.post('http://' + this.globals.restaurant.pudu_robots_ip_sdk + ':' + this.globals.restaurant.pudu_robots_port_sdk + '/api/delete/device', params, {})
            .subscribe(res => {
                if (res['data']['success']) {
                    this.globals.restaurant.pudu_robots_service_up = false;
                    //en el restaurante marcamos que tiene el dispositivo conectado
                    this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
                        'pudu_robots_service_up': false,
                    });
                }
            });
        this.loadingPopup.dismiss();
    }

    puduGetGroupsRobots() {
        this.http.get('http://' + this.globals.restaurant.pudu_robots_ip_sdk + ':' + this.globals.restaurant.pudu_robots_port_sdk + '/api/robot/groups?device=' + this.globals.restaurant.pudu_robots_sdk_device_id, {})
            .subscribe(res => {
                this.group_id = res['data']['robotGroups'][0].id;
                this.puduGetGroupRobots(res['data']['robotGroups'][0].id);
            });
    }

    puduGetGroupRobots(group_id) {
        this.http.get('http://' + this.globals.restaurant.pudu_robots_ip_sdk + ':' + this.globals.restaurant.pudu_robots_port_sdk + '/api/robots?device=' + this.globals.restaurant.pudu_robots_sdk_device_id + '&group_id=' + group_id, {})
            .subscribe(res => {
                this.puduGetMap(res['data']['robots'][0].id);
            });

    }

    puduGetMap(robot_id) {
        this.http.get('http://' + this.globals.restaurant.pudu_robots_ip_sdk + ':' + this.globals.restaurant.pudu_robots_port_sdk + '/api/robot/map?device_id=' + this.globals.restaurant.pudu_robots_sdk_device_id + '&robot_id=' + robot_id, {})
            .subscribe(res => {
                for (let element of res['data']['map']['elements']) {
                    if (element.type == 'source' && element.mode == 'table') {//mirar source y mode para asegurarnos que son la mesas
                        this.tables_robot.push(element);
                        this.table_robot_ids.push(element.id);
                    }
                }
                //sincronizar tables
                this.syncTables();
            });
    }

    async puduGetRobotsInfo() {
        this.robots = [];
        if (this.globals.restaurant.pudu_robots_service_up) {
            this.group_id = await this._puduGetGroupRobots();
            await this._puduGeRobots();
        }
    }

    async _puduGetGroupRobots() {
        ;
        const response = await this.http.get('http://' + this.globals.restaurant.pudu_robots_ip_sdk + ':' + this.globals.restaurant.pudu_robots_port_sdk + '/api/robot/groups?device=' + this.globals.restaurant.pudu_robots_sdk_device_id, {}).toPromise();
        return response['data']['robotGroups'][0].id;

    }

    async _puduGeRobots() {
        await this.http.get('http://' + this.globals.restaurant.pudu_robots_ip_sdk + ':' + this.globals.restaurant.pudu_robots_port_sdk + '/api/robots?device=' + this.globals.restaurant.pudu_robots_sdk_device_id + '&group_id=' + this.group_id, {})
            .subscribe(res => {
                for (var robot of res['data']['robots']) {
                    this._puduGetRobotInfo(robot);
                }
            });
    }

    async _puduGetRobotInfo(robot) {
        await this.http.get('http://' + this.globals.restaurant.pudu_robots_ip_sdk + ':' + this.globals.restaurant.pudu_robots_port_sdk + '/api/robot/status?device_id=' + this.globals.restaurant.pudu_robots_sdk_device_id + '&robot_id=' + robot.id, {})
            .subscribe(res => {
                robot.robotPower = res['data']['robotPower'];
                robot.chargeStage = res['data']['chargeStage'];
                robot.moveState = res['data']['moveState'];
                this.robots.push(robot);
            });
    }

    syncTables() {
        for (let table of this.tables) {
            var index = this.tables_robot.findIndex(x => x.id == table.name);
            if (index > -1) {
                if (table.pudu_table_id == undefined || table.pudu_table_id == null || table.pudu_table_id == '') {//si no existe pudu_table_id, lo creamos
                    table.pudu_table_id = this.tables_robot[index].id;
                }
            }
        }
    }

    updateTablesWithPuduIds() {
        if (this.checkNoIdDuplicates()) {
            //toast con error de duplicados
            let toast = this.toastCtrl.create({
                message: this.translate.instant('general-hay-mesas-con-el-mismo-Id-de-mesa-del-mapa-de-pudu'),
                duration: 3000,
                position: 'top'
            });
            toast.present();
        } else {
            //guardamos en firebase
            this.updateTablesInFirebase();
        }
    }

    async updateTablesInFirebase() {
        for (let table of this.tables) {
            if (table.pudu_table_id != undefined && table.pudu_table_id != null && table.pudu_table_id != '') {
                //actualizamos en firebase
                await this.configurationServices.afs.collection('tables').doc(table.UID).update({
                    'pudu_table_id': table.pudu_table_id,
                });
            }
        }
    }

    checkNoIdDuplicates() {
        var ids = [];
        for (let table of this.tables) {
            if (table.pudu_table_id != undefined && table.pudu_table_id != null && table.pudu_table_id != '') {
                if (ids.indexOf(table.pudu_table_id) > -1) {
                    return true;
                } else {
                    ids.push(table.pudu_table_id);
                }
            }
        }
        return false;
    }

    getFreeRobotToServeTable() {
        var freeRobotToServeTable = '';
        this.http.get('http://' + this.globals.restaurant.pudu_robots_ip_sdk + ':' + this.globals.restaurant.pudu_robots_port_sdk + '/api/robot/groups?device=' + this.globals.restaurant.pudu_robots_sdk_device_id, {})
            .subscribe(res => {

                this.http.get('http://' + this.globals.restaurant.pudu_robots_ip_sdk + ':' + this.globals.restaurant.pudu_robots_port_sdk + '/api/robot/state?device_id=' + this.globals.restaurant.pudu_robots_sdk_device_id + '&group_id=' + res['data']['robotGroups'][0].id + '&timeout=5&count=5')
                    .subscribe(res => {
                        for (let robot of res['data']['state']) {
                            if (freeRobotToServeTable == '' && robot.robotState == 'Free') {
                                freeRobotToServeTable = robot.robotId;
                                this.goToTable(freeRobotToServeTable);
                            }
                        }
                    });
            });


    }

    goToTable(robotId) {

        var params = {
            deviceId: this.globals.restaurant.pudu_robots_sdk_device_id,
            robotId: robotId,
            type: "new",
            deliverySort: "auto",
            executeTask: true,
            trays: [{
                destinations: [{
                    destination: "Despatx 8",
                    id: "Despatx 8"
                }]
            }]
        };

        this.http.post('http://' + this.globals.restaurant.pudu_robots_ip_sdk + ':' + this.globals.restaurant.pudu_robots_port_sdk + '/api/robot/delivery/task', params, {})
            .subscribe(res => {
            },
                err => {
                });
    }

    getPuduRobots() {
        this.puduGetRobotsInfo();
    }

    goBack() {
        this.globals.side_menu_config_active = '';
        if (this.navCtrl.canGoBack())
            this.navCtrl.pop();
        else
            this.navCtrl.setRoot(ConfigurationPage);
    }



}


// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-pudu-robots/configuration-pudu-robots.ts